/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';

import { Headline, Richtext, Select, Button } from '../../elements';
import { ImageSlider, Layout, Accordion, SizeConfiguration } from '../../components';
import { products } from '../../data/products.json';
import { checkSizeLandscape, checkSizePortrait } from '../../helper/conditions';

import { AppContext } from '../../context/AppContext';
import { OVERVIEW } from '../../navigation/routes';
import { UPDATE_ELEVATOR_DATA, SET_MODE } from '../../context/ActionTypes';
import styles from './ProductDetail.module.scss';

const ProductDetail = () => {
	const { state, dispatch } = React.useContext(AppContext);
	const {
		handleSubmit,
		formState: { errors },
		control,
		watch,
	} = useForm({ criteriaMode: 'all', mode: 'onSubmit' });
	const navigate = useNavigate();
	const params = useParams();
	const [product, setProduct] = React.useState();
	const orientation = params.productSlug.split('-')[1];

	const { height_of_cabin, width_of_cabin } = state.configuration.elevators[state.elevatorIndex];

	React.useEffect(() => {
		const prod = products.find((p) => p.slug === params.productSlug.split('-')[0]);

		if (!prod) navigate(-1);
		else {
			setProduct(prod);
		}
	}, []);

	const sizeOptions = () => {
		let options = [];

		if (product.slug === 'mediascreen' || product.slug === 'schindlermedianetwork') {
			options = [...product.options.portrait, ...product.options.landscape];
		}

		if (product.slug === 'adscreen' || product.slug === 'smartmirror') {
			product.options[orientation === 'full' ? 'portrait' : 'landscape'].forEach((item) => {
				if (orientation === 'full') {
					if (checkSizePortrait(item.key, width_of_cabin, height_of_cabin)) options.push(item);
				}

				if (orientation === 'half') {
					if (checkSizeLandscape(item.key, width_of_cabin, height_of_cabin)) options.push(item);
				}
			});
		}

		return options;
	};

	const onSubmit = (data) => {
		dispatch({
			type: UPDATE_ELEVATOR_DATA,
			payload: { completed: true, product: { name: product.name, ...data } },
		});
		dispatch({ type: SET_MODE, payload: 'completed' });

		navigate(OVERVIEW);
	};

	const setSliderImages = () => {
		const isAdScreenOrSmartMirror = product.slug === 'adscreen' || product.slug === 'smartmirror';

		if (isAdScreenOrSmartMirror) {
			return product.images[`${orientation}_height`].map(
				(imgName) => require(`../../assets/images/products/slider/${imgName}`).default,
			);
		} else {
			return product.images.map(
				(imgName) => require(`../../assets/images/products/slider/${imgName}`).default,
			);
		}
	};

	if (!product) return null;

	return (
		<Layout>
			<Headline variant='subtitle'>{product.name}</Headline>
			<Headline variant='h2'>{product.title}</Headline>

			<Richtext>
				<p>{product.inro}</p>
			</Richtext>

			<ImageSlider images={setSliderImages()} sliderHeight='440px' />

			<Headline variant='h3'>{product.description.title}</Headline>
			<Richtext>
				<p dangerouslySetInnerHTML={{ __html: product.description.text }}></p>
			</Richtext>

			<Accordion title='Ihre Benefits'>
				<Richtext>
					{product.benefits.map((item, index) => (
						<p key={`benefits_${index}`}>{item}</p>
					))}
				</Richtext>
			</Accordion>

			{product.specifications.length > 0 ? (
				<Accordion title='Spezifikationen'>
					<div className={styles.specifications}>
						{product.specifications.map((item, index) => (
							<div key={`spec_${index}`} className={styles.specificationsItem}>
								<span>{item.name}</span>
								<span>{item.value}</span>
							</div>
						))}
					</div>
				</Accordion>
			) : null}

			<Headline variant='h3'>Konfigurieren Sie ihren {product.name}</Headline>
			<SizeConfiguration sizes={sizeOptions()} selectedSize={watch('size')} />

			<form className={styles.form} onSubmit={handleSubmit(onSubmit)}>
				<Controller
					control={control}
					name='size'
					rules={{ required: true }}
					defaultValue={""}
					render={({ field }) => (
						<Select
							inputRef={field.ref}
							label='Screen'
							options={sizeOptions()}
							name={field.name}
							value={
								field.value
									? [...product.options.portrait, ...product.options.landscape].find(
											(opt) => opt.value === field.value,
									  ).label
									: null
							}
							onChange={(val) => field.onChange(val)}
							errors={errors}
						/>
					)}
				/>

				<div className={styles.footer}>
					<Button
						type='button'
						title='Zurück'
						variant='outline'
						onClick={() => navigate(-1, { replace: true })}
					/>

					<Button type='submit' title='Weiter' />
				</div>
			</form>
		</Layout>
	);
};

export default ProductDetail;
